import * as types from './mutation-types'

export default {
  [types.BOOTSTRAP_CURRENCIES] (state, data) {
    state.currencies = data.currencies
  },

  [types.SET_DEFAULT_CURRENCY] (state, data) {
    state.defaultCurrency = data.default_currency
  },

  [types.ADD_CURRENCY] (state, data) {
    state.currencies.push(data)
  },
  [types.UPDATE_CURRENCY](state, data) {
    // let updateCurrency = state.currencies.findIndex(currency => currency.id === data.id)
    // console.log(state.currencies[updateCurrency])
    // console.log(updateCurrency)
    // console.log(data)
    // state.currencies[updateCurrency] = data

    let pos = state.currencies.findIndex(currency => currency.id === data.id)
    state.currencies.splice(pos, 1)
    state.currencies = [data, ...state.currencies]

  }
}
